import { render, staticRenderFns } from "./HistoryCompareFooter.vue?vue&type=template&id=37f2bfae"
import script from "./HistoryCompareFooter.vue?vue&type=script&lang=ts"
export * from "./HistoryCompareFooter.vue?vue&type=script&lang=ts"
import style0 from "./HistoryCompareFooter.vue?vue&type=style&index=0&id=37f2bfae&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37f2bfae')) {
      api.createRecord('37f2bfae', component.options)
    } else {
      api.reload('37f2bfae', component.options)
    }
    module.hot.accept("./HistoryCompareFooter.vue?vue&type=template&id=37f2bfae", function () {
      api.rerender('37f2bfae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Viewer/HistoryCompareFooter.vue"
export default component.exports